<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="show-issue-voucher-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalIssueVoucher"
    ></button>
    <div
      class="modal fade"
      id="modalIssueVoucher"
      tabindex="-1"
      aria-labelledby="modalIssueVoucherLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title justify-content-center">Issue Voucher</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div class="row mb-3 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Mobile</label>
              </div>
              <div class="col-7 ps-0">
                <span style="font-size: 18px;">{{ form.phone_number }}</span>
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Voucher <span class="text-danger">*</span></label>
              </div>
              <div class="col-7 ps-0">
                <Multiselect
                  v-model="form.voucher_id"
                  :options="vouchers"
                  :canClear="false"
                  @change="getVoucherSetDetail"
                />
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold"></label>
              </div>
              <div class="col-7 ps-0">
                <span class="text-dark">Where is the voucher valid: </span>{{ voucher_set_voucher_valid }}<br>
                <span class="text-dark">Which product is this voucher applied to: </span>{{ voucher_set_applied_to }}<br>
                <span class="text-dark">Expired Date: </span>{{ voucher_set_expiry_date }}<br>
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Issue Quantity </label>
              </div>
              <div class="col-7 ps-0">
                {{ 1 }}
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Voucher Code</label>
              </div>
              <div class="col-7 ps-0">
                <input  type="radio" name="voucher_code" id="voucher_code" checked disabled>
                <label for="voucher_code">Different Voucher Code (Code is auto-generated)</label>
              </div>
            </div>
            <div class="row mb-8 align-items-center">
              <div class="col-5 text-end pe-3">
                <label class="form-label label-bold">Reason <span class="text-danger">*</span></label>
              </div>
              <div class="col-7 ps-0">
                <material-textarea v-model="form.reason" />
              </div>
            </div>
            <div class="text-center">
              <button class="btn btn-primary" @click="okIssue" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import MaterialLoading from "@/components/MaterialLoading.vue";
import $ from "jquery";
import MemberService from "../../../services/member.service";
import SettingVoucherService from "../../../services/settingVoucher.service";
import moment from "moment";
import MaterialTextarea from "@/components/MaterialTextarea.vue";

export default {
  name: "IssueVoucherModal",
  components: {
    MaterialSnackbar,
    Multiselect,
    MaterialLoading,
    MaterialTextarea
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    idSelected: {
      type: Number,
      default: 0,
    },
    member: {
      type: Object,
      required: true,
    },
  },
  watch: {
    keyReload: {
      handler() {
        this.initializeData();
      }
    }
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      loading: false,
      vouchers: [],
      voucher_set_expiry_date: 'N/A',
      voucher_set_applied_to: 'N/A',
      voucher_set_voucher_valid: 'N/A',
      form: {
        phone_number: this.member.phone_number,
        member_id: this.member.id,
        voucher_id: 0,
        reason: '',
      }
    };
  },
  methods: {
    async initializeData() {
      // Reset form data
      this.form = {
        phone_number: this.member.phone_number,
        member_id: this.member.id,
        voucher_id: 0,
        reason: '',
      };
      this.voucher_set_expiry_date = 'N/A';
      this.voucher_set_applied_to = 'N/A';
      this.voucher_set_voucher_valid = 'N/A';
      this.loading = false;
      this.message = "";
      this.snackbar = null;

      // Load fresh data
      await Promise.all([
        this.selectVoucher()
      ]);

      // Set default values after data is loaded
      this.form.branch_id = this.branchs[0]?.value || 0;
      this.form.employee_name = this.staffs[0]?.value || 0;
    },

    selectVoucher() {
      this.vouchers = [];
      MemberService.getVoucherAvailabel().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.vouchers = response.data.data
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
        }
      );
    },

    getVoucherSetDetail(voucher_set_id) {
      if(voucher_set_id) {
        SettingVoucherService.getDataVoucherDetail(voucher_set_id).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.voucher_set_expiry_date = response.data.data.reward.expiry_date ? moment(response.data.data.reward.expiry_date).format('D MMMM YYYY') : this.voucher_set_expiry_date;

              if (response.data.data.reward.fixed_date === 1) {
                this.voucher_set_expiry_date = response.data.data.reward.expiry_date ? moment(response.data.data.reward.expiry_date).format('D MMMM YYYY') : this.voucher_set_expiry_date;
              } else if (response.data.data.reward.expired_after === 1 && response.data.data.reward.time_number !== null) {
                const currentDate = this.created_at ? moment(this.created_at) : moment() ;
                const newExpiryDate = currentDate.add(response.data.data.reward.time_number, 'days').format('D MMMM YYYY');
                this.voucher_set_expiry_date = newExpiryDate;
              }

              const idArrayStore = response.data.data.reward.apply_for_store;

              const selectedLabels = idArrayStore.map(id => {
                const item = response.data.data.branches.find(item => item.value === id);
                return item ? item.label : null;
              }).filter(label => label !== null);

              const resultStore = selectedLabels.length === response.data.data.branches.length - 1 ? 'All Branches' : selectedLabels.join(', ');

              const idArrayProduct = response.data.data.reward.apply_for_product;

              const selectedLabelsProduct = idArrayProduct.map(id => {
                const item = response.data.data.items.find(item => item.value === id);
                return item ? item.label : null;
              }).filter(label => label !== null);

              const resultProduct = selectedLabelsProduct.length === response.data.data.items.length - 1 ? 'All Product' : selectedLabelsProduct.join(', ');

              if(resultStore != "") {
                this.voucher_set_voucher_valid = resultStore;
              }
              if(resultProduct != "") {
                this.voucher_set_applied_to = resultProduct;
              }
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
          }
        );
      }
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    validateForm() {
      const requiredFields = [
        { field: 'phone_number', message: 'Phone Number is required' },
        { field: 'voucher_id', message: 'Voucher is required' },
        { field: 'reason', message: 'Reason is required' },
      ];

      for (const item of requiredFields) {
        const value = this.form[item.field];
        if (item.condition ? item.condition(value) : !value) {
          this.message = item.message;
          this.snackbar = "danger";
          this.setTimeOutNotification();
          return false;
        }
      }
      return true;
    },

    okIssue() {
      this.loading = true;
      if (!this.validateForm()) {
        this.loading = false;
        return;
      }
      var dataForm = {
        voucher_id: this.form.voucher_id,
        member_id: this.member.id,
        reason: this.form.reason
      };
      MemberService.issueVoucher(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.$emit('voucher-issued');
            this.voucherId = 0
            this.snackbar = "success"
            this.message = "Sent voucher successful"
            this.loading = false;
            $('.btn-close-modal').click();
            this.setTimeOutNotification()
          } else {
            this.snackbar = "danger"
            this.message = response.data.result.message
            this.setTimeOutNotification()
          }
          this.loading = false
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 99999;
}

.modal-dialog {
  max-width: 75vw;
  max-width: 750px !important;
}

.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.table-responsive::-webkit-scrollbar {
  height: 7px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #888;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.option-btn {
  background: #2677D9 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 4px !important;
  font-size: 16px !important;
  transition: background 0.2s, color 0.2s !important;

}
.option-btn.active {
  background: #fff;
  color: #2677D9;
  border: 2px solid #2677D9;
  font-weight: bold;
}

.label-bold {
  font-weight: 600;
  font-size: 16px;
  color: #344767;
  margin-bottom: 0 !important;
}
.text-danger {
  color: #e74c3c !important;
}
.form-select, .form-control {
  font-size: 16px;
  border-radius: 6px;
  min-height: 40px;
}
.btn-primary {
  background: #2677D9  !important;
  border: none !important;
  font-weight: bold;
  color: #fff !important;
}
.btn-primary:active, .btn-primary:focus {
  background: #2d2d7f;
  border-color: #2d2d7f;
}

.modal-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
}

.modal-title {
  flex: 1;
  text-align: center;
  margin: 0;
}

.btn-close-modal {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  color: #888;
  background: none;
  border: none;
}
</style>

